export default __webpack_public_path__ + "static/media/folder-files-and-folders-svgrepo-com.32259a2b.svg";